import React from 'react';
import Link from 'next/link';

export default function CTABanner() {
  return (
    <section
      style={{
        background: '#f7f9fc',
        padding: '80px 60px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <p className="section-label" style={{ marginBottom: '16px' }}>READY TO GET STARTED?</p>
        <h2 style={{ marginBottom: '20px' }}>view your options</h2>
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '1rem',
            color: '#4a5568',
            lineHeight: 1.75,
            maxWidth: '560px',
            margin: '0 auto 32px',
          }}
        >
          Answer some basic questions in less than 3 minutes with no impact to your credit score and compare multiple offers.{' '}
          <strong style={{ fontWeight: 700, color: '#1a2b4a' }}>YOU</strong> are in the driver&apos;s seat!
        </p>
        <Link
          href="/apply"
          className="btn-primary"
          style={{ display: 'inline-block', marginBottom: '40px' }}
        >
          Get My Offers
        </Link>

        {/* App UI Mockup */}
        <div
          style={{
            maxWidth: '700px',
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            margin: '0 auto',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          }}
        >
          <img
            src="/assets/images/lendo_app_mockup.png"
            alt="Lendo business loan application interface showing a multi-step form with loan type selection and business details"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          section[style*="padding: 80px 60px"] {
            padding: 60px 24px !important;
          }
        }
      `}</style>
    </section>
  );
}
